import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsPartNumberStyles {
    labelText?: TypographyProps;
    valueText?: TypographyProps;
}

export const partNumberStyles: ProductDetailsPartNumberStyles = {
    labelText: {
        css: css`
            margin-right: 4px;
        `,
    },
    valueText: {
        css: css`
            margin-bottom: 5px;
            font-size: 16px;
            font-weight: 400;
            letter-spacing: 0;
            line-height: 19px;
            color: #006bc0;
            @media all and (min-width: 0px) and (max-width: 768px) {
                margin-bottom: 0px;
                padding: 0 15px;
            }
        `,
    },
};

const styles = partNumberStyles;

const ProductDetailsPartNumber: React.FC<Props> = ({ product }) => {
    if (!product.productNumber || product.properties.isFamilySeries === "True") {
        return null;
    }

    return (
        <Typography {...styles.valueText} as="p" data-test-selector="ProductDetailsPartNumber">
            <Typography {...styles.labelText}>{translate("Model#")}</Typography>
            {product.productNumber}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsPartNumber),
    definition: {
        displayName: "Part Number",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
